module.exports = __webpack_public_path__ + "img/drag_handle_black_24dp.1a12fa67.svg";